import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import {
    FormActionHandlerExecutionInjectableProps,
    withFormActionHandlerExecution,
} from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { FormActionHandler } from "../../Internals/FormActionHandlers/FormActionHandler";
import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";
import { withResolvePaths } from "../../withResolvePaths";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { withViewModelSelect } from "../../withViewModelSelect";

import { Kebab } from "./Kebab";

export interface KebabContainerProps extends FormActionHandlerExecutionInjectableProps {
    onOpen?: FormActionHandler;
    onClose?: FormActionHandler;
    disabled?: boolean;
    disabled2?: EvaluableProp<boolean>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapStateToProps = (state: FullFormState, ownProps: KebabContainerProps) => {
    const { disabled2, processEvaluableProp } = ownProps;
    if (isNotNullOrUndefined(disabled2)) {
        return {
            disabled: processEvaluableProp(state, disabled2),
        };
    }
    return {};
};

const mapDispatchToProps = (_: CandyDispatch, ownProps: KebabContainerProps) => ({
    onOpen: async () => {
        if (isNotNullOrUndefined(ownProps.onOpen)) {
            await ownProps.executeFormActionHandler(ownProps.onOpen);
        }
    },
    onClose: async () => {
        if (isNotNullOrUndefined(ownProps.onClose)) {
            await ownProps.executeFormActionHandler(ownProps.onClose);
        }
    },
});

export const KebabContainer = withResolvePaths(
    withFormActionHandlerExecution(
        withViewModelSelect(
            withEvaluators(
                connect(
                    mapStateToProps,
                    mapDispatchToProps
                )(withTestPageObjectRegistration(withControlDebugInfo(Kebab)))
            )
        )
    )
);
